export function getRuntimeConfig() {
  const cfg = (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__) ? window.__RUNTIME_CONFIG__ : {};

  const pageOrigin = (typeof window !== 'undefined' && window.location?.origin) ? window.location.origin : '';
  const pageHostname = (typeof window !== 'undefined' && window.location?.hostname) ? window.location.hostname : '';
  const pageProtocol = (typeof window !== 'undefined' && window.location?.protocol) ? window.location.protocol : '';
  const isIpHost = /^(\d{1,3}\.){3}\d{1,3}$/.test(pageHostname);
  const isLocalHost = pageHostname === 'localhost' || pageHostname === '127.0.0.1' || isIpHost;

  const shouldPreferLocalOrigin = (configuredUrl) => {
    if (!isLocalHost) return false;
    // If user opens the UI via https://<ip>, browsers will attempt TLS to the raw IP.
    // This commonly breaks (no matching vhost/cert) and can cause repeated fetch failures.
    // In that case, stick to the configured domains instead of forcing the local origin.
    if (isIpHost && pageProtocol === 'https:') return false;
    if (!configuredUrl) return true;
    try {
      const configuredHost = new URL(configuredUrl).hostname;
      return configuredHost !== pageHostname;
    } catch {
      return true;
    }
  };

  const configuredApiBase = (cfg.API_BASE_URL || '').trim();
  const apiBase = shouldPreferLocalOrigin(configuredApiBase) ? pageOrigin : (configuredApiBase || pageOrigin);

  const configuredWebdavBase = (cfg.WEBDAV_BASE_URL || '').trim();
  let webdavBase = shouldPreferLocalOrigin(configuredWebdavBase) ? apiBase : (configuredWebdavBase || apiBase);

  // WebDAV over HTTPS with an IP hostname will fail hostname verification on clients when the cert is for a domain.
  // For local-IP access we intentionally prefer plain HTTP.
  if (isIpHost) {
    try {
      const u = new URL(webdavBase);
      // Only force HTTP when the page itself is HTTP. If the UI is loaded over HTTPS,
      // downgrading WebDAV to HTTP causes mixed-content blocking in browsers.
      if (pageProtocol === 'http:' && u.protocol === 'https:') {
        u.protocol = 'http:';
        webdavBase = u.toString().replace(/\/$/, '');
      }
    } catch {
      // If webdavBase isn't a full URL, fall back to explicit host
      webdavBase = `${pageProtocol}//${pageHostname}`;
    }
  }

  const configuredMqttWsUrl = (cfg.MQTT_WS_URL || '').trim();
  const preferLocalMqttWs = isLocalHost && pageProtocol === 'http:';
  const mqttWsUrl = (preferLocalMqttWs && shouldPreferLocalOrigin(configuredMqttWsUrl)) ? '' : configuredMqttWsUrl;

  const mqttUsername = (cfg.MQTT_USERNAME || '').trim();
  const mqttPassword = (cfg.MQTT_PASSWORD || '').trim();
  const cameraWsUrl = (cfg.CAMERA_WS_URL || '').trim();
  const cameraHttpBaseUrl = (cfg.CAMERA_HTTP_BASE_URL || '').trim();

  return {
    API_BASE_URL: apiBase.replace(/\/$/, ''),
    WEBDAV_BASE_URL: webdavBase.replace(/\/$/, ''),
    MQTT_WS_URL: mqttWsUrl,
    MQTT_USERNAME: mqttUsername,
    MQTT_PASSWORD: mqttPassword,
    CAMERA_WS_URL: cameraWsUrl,
    CAMERA_HTTP_BASE_URL: cameraHttpBaseUrl.replace(/\/$/, '')
  };
}
